import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import mock from '../utils/mock';

export interface SaveUserTenantParams {
  userId: string;
  tenantId: string;
}

const saveUserTenant: MutationFunction<boolean, SaveUserTenantParams> = async (
  args,
) => {
  if (isMockServices())
    return await mock(_mockSaveUserTenant().success, {
      delay: 1000,
      failureRate: 0,
    });

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean }>(
    `/shared/users/${args.userId}/allowed-tenants`,
    {
      method: 'POST',
      body: {
        tenantId: args.tenantId,
      },
    },
  );
  if (response.data) return response.data.success;
  throw new Error('Failed to save user tenant');
};

const _mockSaveUserTenant = () => ({
  success: true,
});

export default saveUserTenant;
